// Roomvo script loader and anchor handler
// Extracted from inline script for deferred loading
//
// SRC is the Tile Outlets of America Roomvo account script — the same script
// that runs on the legacy taleoutlets.com site, as supplied by Roomvo. Roomvo
// (Leap Tools) updated it on 2026-07-27 so it is also authorised on the staging
// domain (tileoutlets.myshopify.com), which means it works before and after the
// domain cutover to taleoutlets.com.
//
// This file is the single place the Roomvo script URL is declared: both
// layout/theme.liquid and layout/theme.shogun.landing.liquid load it.
// It previously loaded the BuildDirect account script (b2b/builddirect.js),
// which only resolved SKUs in BuildDirect's Roomvo datasource — that is why the
// visualizer only appeared on a handful of BuildDirect SKUs on this store.
//
// CUSTOM BUTTONS: the PDP renders Roomvo's launch buttons itself, where we want
// them (snippets/roomvo-button.liquid), rather than letting the account script's
// auto-detection place buttons of its own. Nothing in this theme may move a node
// Roomvo created or change a Roomvo button's visibility — see the comment at the
// top of that snippet, and docs/roomvo-integration.md.
//
// AUTOLOAD: the account script scans the page and injects its own "See This In
// My Room" button into anything it recognises, including every card in a
// category grid. Category pages therefore set window.BD_ROOMVO_AUTOLOAD = false
// (see layout/theme.liquid) so the account script is not fetched on page load
// and no buttons appear in the grid. It is still loaded on demand the moment
// someone activates a #roomvo link or a [data-roomvo-open] element, so the
// visualizer keeps working from the nav on those pages.

(function () {
  var SRC = 'https://www.roomvo.com/static/scripts/b2b/tileoutlets.js';

  // ---------------------------------------------------------------------
  // Account script loader
  // ---------------------------------------------------------------------
  function loadAccountScript() {
    if (document.querySelector('script[src="' + SRC + '"]')) return;

    var s = document.createElement('script');
    s.src = SRC;
    s.defer = true;
    s.onerror = function () {
      // Surfaces a wrong/renamed account script or a blocked domain during QA
      // instead of failing silently with permanently hidden buttons.
      console.warn('[Roomvo] Failed to load account script: ' + SRC);
    };
    document.head.appendChild(s);
  }

  if (window.BD_ROOMVO_AUTOLOAD !== false) loadAccountScript();

  // ---------------------------------------------------------------------
  // Anchor handler
  // ---------------------------------------------------------------------
  if (window.__roomvoAnchorsV2) return;
  window.__roomvoAnchorsV2 = true;

  function getHashFromHref(href) {
    try {
      var u = new URL(href, window.location.href);
      return (u.hash || "").toLowerCase();
    } catch (e) {
      // fallback for odd href values
      href = href || "";
      var i = href.indexOf("#");
      return i >= 0 ? href.slice(i).toLowerCase() : "";
    }
  }

  function getRoomvoOpener() {
    // Return a function that opens Roomvo, or null if not ready
    if (window.roomvo && typeof window.roomvo.startStandaloneVisualizer === "function") {
      return function(){ window.roomvo.startStandaloneVisualizer(); };
    }
    if (window.RVWPortal && typeof window.RVWPortal.open === "function") {
      return function(){ window.RVWPortal.open(); };
    }
    if (window.Roomvo && typeof window.Roomvo.open === "function") {
      return function(){ window.Roomvo.open(); };
    }
    if (window.roomvo && typeof window.roomvo.open === "function") {
      return function(){ window.roomvo.open(); };
    }
    return null;
  }

  function openRoomvoWithRetry() {
    // No-op when the script is already there; on a category page (autoload off)
    // this is the fetch that brings the visualizer in.
    loadAccountScript();

    var opener = getRoomvoOpener();
    if (opener) {
      opener();
      return true;
    }

    // Mobile: script may not be ready yet. Retry briefly after the user gesture.
    var tries = 0;
    var maxTries = 60;     // ~6 seconds
    var timer = setInterval(function () {
      tries++;
      var fn = getRoomvoOpener();
      if (fn) {
        clearInterval(timer);
        fn();
      } else if (tries >= maxTries) {
        clearInterval(timer);
        console.warn("[Roomvo] API not ready after retry window.");
      }
    }, 100);

    return true;
  }

  function shouldHandle(el) {
    if (!el) return false;

    // data-roomvo-open always qualifies
    if (el.hasAttribute && el.hasAttribute("data-roomvo-open")) return true;

    // Anchor hashes: accept "#roomvo" even if href is a full URL containing it
    if (el.tagName && el.tagName.toLowerCase() === "a") {
      var href = el.getAttribute("href") || "";
      return getHashFromHref(href) === "#roomvo";
    }

    return false;
  }

  function handler(e) {
    var target = e.target;

    var el = target && target.closest
      ? target.closest('a, [data-roomvo-open]')
      : null;

    if (!shouldHandle(el)) return;

    // Stop menu / drawer scripts from hijacking the click first
    e.preventDefault();
    e.stopPropagation();

    openRoomvoWithRetry();
  }

  // Capture phase is key for mobile menus
  document.addEventListener("click", handler, true);

  // Some mobile menus behave better with touchend
  document.addEventListener("touchend", handler, { capture: true, passive: false });

  // If someone lands on a URL ending in #roomvo, open automatically
  function autoOpenIfHash() {
    if ((window.location.hash || "").toLowerCase() !== "#roomvo") return;
    // Give the Roomvo script a moment
    setTimeout(openRoomvoWithRetry, 0);
  }
  window.addEventListener("hashchange", autoOpenIfHash);
  autoOpenIfHash();
})();
